function scaleRem(remValue) {
  if (remValue === "0rem") {
    return "0rem";
  }

  return "calc(".concat(remValue, " * var(--mantine-scale))");
}

function createConverter(units) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$shouldScale = _ref.shouldScale,
      shouldScale = _ref$shouldScale === void 0 ? false : _ref$shouldScale;

  function converter(value) {
    if (value === 0 || value === "0") {
      return "0".concat(units);
    }

    if (typeof value === "number") {
      var val = "".concat(value / 16).concat(units);
      return shouldScale ? scaleRem(val) : val;
    }

    if (typeof value === "string") {
      if (value === "") {
        return value;
      }

      if (value.startsWith("calc(") || value.startsWith("clamp(") || value.includes("rgba(")) {
        return value;
      }

      if (value.includes(",")) {
        return value.split(",").map(function (val) {
          return converter(val);
        }).join(",");
      }

      if (value.includes(" ")) {
        return value.split(" ").map(function (val) {
          return converter(val);
        }).join(" ");
      }

      if (value.includes(units)) {
        return shouldScale ? scaleRem(value) : value;
      }

      var replaced = value.replace("px", "");

      if (!Number.isNaN(Number(replaced))) {
        var _val = "".concat(Number(replaced) / 16).concat(units);

        return shouldScale ? scaleRem(_val) : _val;
      }
    }

    return value;
  }

  return converter;
}

var rem = createConverter("rem", {
  shouldScale: true
});
var em = createConverter("em");
export { em, rem };